import { gql } from '@apollo/client';

export const FETCH_CREW_MEMBER_ACTION_LOG = gql`
	query getCrewMemberActionLog(
		$filter: CrewMemberUnifiedActionLogViewFilter!
		$pagination: PaginationInput!
	) {
		searchActionLogsByCrewMemberIds(filter: $filter, pagination: $pagination) {
			results {
				id
				crewMemberId
				type
				defaultMessage
				parameters {
					... on WorkAssignmentCreatedLog {
						__typename
						activityType
						status
						stationFrom
						stationTo
						fromTimestamp
						toTimestamp
						timezone
						disregardedEligibilityRules
					}
					... on WorkAssignmentStatusUpdatedLog {
						__typename
						activityType
						reason
						stationFrom
						stationTo
						fromTimestamp
						toTimestamp
						timezone
						oldStatus
						newStatus
					}
					... on WorkAssignmentTimeUpdatedLog {
						__typename
						activityType
						status
						oldFromTime
						oldToTime
						newFromTime
						newToTime
						timezone
						stationFrom
						stationTo
						fromTimestamp
						toTimestamp
						reason
					}
					... on WorkAssignmentActualCreatedLog {
						__typename
						activityType
						reason
						stationFrom
						stationTo
						fromTimestamp
						toTimestamp
						timezone
					}
					... on WorkAssignmentBreakdownLog {
						__typename
						activityType
						stationFrom
						stationTo
						fromTimestamp
						toTimestamp
						timezone
						reason
						note
					}
					... on CrewMemberInfoUpdatedLog {
						__typename
						newValues {
							key
							value
						}
					}
					... on CrewMemberHomeBaseLog {
						__typename
						cityName
						effectiveTimestamp
						expireTimestamp
						timezone
					}
					... on CrewMemberAbsenceLog {
						__typename
						reason
						fromTimestamp
						toTimestamp
						timezone
					}
					... on CrewMemberEmploymentTypeLog {
						__typename
						employmentType
						effectiveTimestamp
						timezone
					}
					... on CrewMemberLocationChangeLog {
						__typename
						cityName
						effectiveTimestamp
						timezone
					}
					... on CrewMemberHoldDownLog {
						__typename
						originalCrewMemberId
						originalCrewMemberFullName
						effectiveTimestamp
						expireTimestamp
						timezone
					}
				}
				createdAt
				createdBy
			}
			page {
				page
				size
				totalPages
				totalCount
			}
		}
	}
`;
